import { z } from "@reflag/shared/utils/zod";

export const ExternalIdSchema = z.string().min(1).max(256);
export const ExternalIdArraySchema = z.array(ExternalIdSchema);
